import { intersection } from "lodash";
import { useSelector } from "react-redux";
import { IReduxState } from "../utils/types";

function isArrayWithLength(arr: any) {
    return (Array.isArray(arr) && arr.length)
}

const GetAllowedRoutes = (routes: any) => {
    const AuthState = useSelector((state: IReduxState) => state.Auth);
    const roles = AuthState?.role
    // const roleState = useSelector((state: IReduxState) => state.Roles)

    // const getAccess = roles.map((roleName) => {
    //     return roleState.roles.filter((item: any) => item.role_name === roleName)[0]
    // })

    // const temp: any = [];
    // getAccess && getAccess.map((access: any) => {
    //     access?.access_screen.map((screen: any) => {
    //         if (!temp.includes(screen)) {
    //             temp.push(screen)
    //         }
    //     })
    // })

    // const tempAccessScreen: any = []
    // temp.map((screen: any) => {
    //     const xy = routes.filter((route: any) => route?.title === screen)[0]
    //     if (xy) tempAccessScreen.push(xy)
    // })

    // return tempAccessScreen

    return routes.filter((route: any) => {
        if (!route?.permission) return true;
        else if (!isArrayWithLength(route?.permission)) return true;
        else return intersection(route?.permission, roles).length;
    });
}

export default GetAllowedRoutes;